import { StylesConfig } from 'react-select';
import { assertNotNil, IReactSelectOption } from '../../../../utils/types';
import {
  INestedFieldQueryQueryVariables,
  ITagOptionInput,
  TagOption,
} from '../../../../utils/apollo/graphqlSchema';
import { MaybeNil } from '../../../../utils/interfaces';

export const nestedFieldReactSelectStyles: StylesConfig<
  IReactSelectOption,
  false,
  never
> = {
  control: (base) => ({
    ...base,
    minWidth: 'auto',
  }),
};

export const convertToOptions = (items: string[]): IReactSelectOption[] =>
  items.map((v: string): IReactSelectOption => {
    return { value: v, label: v };
  });

export const extractQueryOptions = (
  tags: ITagOptionInput[],
): Pick<INestedFieldQueryQueryVariables, 'func' | 'context' | 'events'> => {
  const fieldTag = tags.find((t) => t.tag === TagOption.Field);
  assertNotNil(fieldTag);
  assertNotNil(fieldTag.field);
  return fieldTag.field;
};

export const findOption = (
  typeOptions: IReactSelectOption[],
  v: MaybeNil<IReactSelectOption['value']>,
) => typeOptions.find(({ value }) => value === v);
